export default "__VITE_ASSET__Bzhtm7BD__"